// 取り込み画像・切り抜き結果の実体（描画可能ソース）を保持するストア。
// 画像データはこのストア＝メモリ内にのみ存在し、サーバーへは送信しない
export type DrawableAsset = HTMLCanvasElement | ImageBitmap;

const store = new Map<string, DrawableAsset>();
let seq = 0;

export function putAsset(asset: DrawableAsset): string {
  const id = `asset-${++seq}`;
  store.set(id, asset);
  return id;
}

export function getAsset(id: string): DrawableAsset | null {
  return store.get(id) ?? null;
}

export function assetDimensions(id: string): { width: number; height: number } | null {
  const asset = store.get(id);
  if (!asset) return null;
  return { width: asset.width, height: asset.height };
}
